import * as Sentry from '@sentry/react';
import { scrubSentryBreadcrumb, scrubSentryEvent } from '@shared/scrubUrlTokens';
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initAnalytics } from "./lib/analytics";
import { hideSplashWhenReady } from "./lib/native/splash";

Sentry.init({
  dsn: "https://a363d7e9ee3a14abdbd3cfb538869a51@o4511055959425024.ingest.us.sentry.io/4511055971549184",
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  // The page URL and fetch URLs carry working tokens (order-summary `?t=`, magic
  // links, intake links) — redact them from events and breadcrumbs.
  beforeSend: scrubSentryEvent,
  beforeSendTransaction: scrubSentryEvent,
  beforeBreadcrumb: scrubSentryBreadcrumb,
});

// Marketing analytics (GA4 + Meta Pixel) — self-gates to the demo/public funnel
// only, and is a no-op unless VITE_GA_MEASUREMENT_ID / VITE_META_PIXEL_ID are set.
initAnalytics();

createRoot(document.getElementById("root")!).render(<App />);

// Native shell only: dismiss the launch splash now that React has mounted.
// capacitor.config.ts no longer auto-hides it on a timer — see lib/native/splash.
hideSplashWhenReady();
